import React from 'react';
import VehicleMonitoringTable from './VehicleMonitoringTable'
import DeviceTransmissionTable from './DeviceTransMissionTable';
import FrequencyBucketTable from './FrequencyBucketTable';
import Kpis from './Kpis/KPI';
import CustomFilter from './Filter/CustomFilter';
import { DeviceHealthContextProvider } from './context/Context';

const DeviceHealth = () => {
    return (
        <div>
            <DeviceHealthContextProvider>
                <CustomFilter />
                <Kpis />
                {/* <VehicleMonitoringTable /> */}
                <FrequencyBucketTable />
                <DeviceTransmissionTable />
            </DeviceHealthContextProvider>
        </div>
    );
}

export default DeviceHealth;
